import { render, staticRenderFns } from "./RegionReport.vue?vue&type=template&id=6986beff&"
import script from "./RegionReport.vue?vue&type=script&lang=js&"
export * from "./RegionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports